module.exports = __webpack_public_path__ + "static/media/mockup@2x.ccbb6bae.png";